import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const features = [
  {
    icon: FiIcons.FiTv,
    title: "The Ultimate Broadcast Hub",
    description: "Supports YouTube, Vimeo, Twitch, or HLS CDN. Seamlessly integrate high-quality live streams with deep virtual interaction."
  },
  {
    icon: FiIcons.FiCoffee,
    title: "Virtual Networking Lounge",
    description: "A professional yet casual space for mixers. Includes profile creation, discussion groups, and private video calls."
  },
  {
    icon: FiIcons.FiCpu,
    title: "Infrastructure You Control",
    description: "Ultra low-cost video conferencing. Route calls through your own AWS Chime account for massive cost savings."
  },
  {
    icon: FiIcons.FiLayout,
    title: "Exhibitor Power-Ups",
    description: "Customizable booths for sponsors to showcase products via video and materials with integrated lead capture."
  },
  {
    icon: FiIcons.FiBookOpen,
    title: "Dynamic Content Delivery",
    description: "Go beyond booths. Use flexible Pages to deliver knowledge bases or course content directly within your world."
  },
  {
    icon: FiIcons.FiUsers,
    title: "Collaborative Hosting",
    description: "Scale your management. Easily add co-hosts and moderators to help navigate schedules and manage Q&A."
  },
  {
    icon: FiIcons.FiRefreshCw,
    title: "Automated Ecosystem",
    description: "Connect your entire stack. Native support for Zapier, Pabbly, and Webhooks for automated registrations."
  },
  {
    icon: FiIcons.FiGlobe,
    title: "White-Label Brand Mastery",
    description: "Your brand, your domain. Full CNAME support ensures your event lives on your territory for a professional feel."
  }
];

const AvatarsFeatures = () => {
  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold text-indigo-600 tracking-wide uppercase">The Avatars Edge</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Everything you need for legendary events
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
            We've combined enterprise technical capabilities with a user-friendly interface to host experiences at a fraction of the cost.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative p-8 bg-gray-50 rounded-2xl hover:shadow-xl transition-shadow duration-300 border border-gray-100 group"
            >
              <div className="mb-6 inline-flex items-center justify-center p-3 bg-indigo-600 rounded-xl shadow-lg group-hover:scale-110 transition-transform">
                <SafeIcon icon={feature.icon} className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AvatarsFeatures;